<div class="loader-wrapper">
  <div class="loader">
    <div class="loader4"></div>
  </div>
</div>
